import { useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { Dropdown } from 'primereact/dropdown';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';
import useFormState from '../../../../shared/hooks/useFormState';

const padreOptions = (familias = []) => [
    { label: "(Raíz - Sin padre)", value: 0 },
    ...familias.filter((f) => f.activa !== false),
];

export const AgregarFamiliaDialog = ({ visible, onCancel, onConfirm, familias = [], initialPadreId = 0 }) => {
    const { values, setField, reset } = useFormState({
        nombre: '',
        orden: 0,
        padreId: 0,
        ordenAuto: true,
    });

    useEffect(() => {
        if (visible) {
            reset({
                nombre: '',
                orden: 0,
                padreId: initialPadreId || 0,
                ordenAuto: true,
            });
        }
    }, [visible, initialPadreId]); // eslint-disable-line react-hooks/exhaustive-deps

    const handleCancel = () => {
        reset({ nombre: '', orden: 0, padreId: 0, ordenAuto: true });
        onCancel();
    };

    const handleConfirm = () => {
        if (onConfirm) {
            onConfirm({ nombre: values.nombre.trim(), orden: values.ordenAuto ? 0 : values.orden, padreId: values.padreId });
        }
        handleCancel();
    };

    const headerText = values.padreId > 0 ? "Agregar Subfamilia" : "Agregar Familia";

    const footer = (
        <div className="flex justify-content-end gap-2">
            <Button className="p-button-text" label="Cancelar" onClick={handleCancel} />
            <Button className="p-button" label="Agregar" disabled={!values.nombre.trim()} onClick={handleConfirm} />
        </div>
    );

    return (
        <Dialog
            header={headerText}
            visible={visible}
            onHide={handleCancel}
            footer={footer}
            style={{ width: '50vw' }}
        >
            <div className="flex flex-column gap-3">
                <div className="field">
                    <label htmlFor="nombre-familia" className="block font-medium mb-2">Nombre de la familia</label>
                    <InputText
                        id="nombre-familia"
                        value={values.nombre}
                        onChange={(e) => setField('nombre', e.target.value.toUpperCase())}
                        className="w-full"
                        placeholder="Ej: HERRAMIENTAS"
                        autoFocus
                    />
                </div>
                <div className="field">
                    <label htmlFor="padre-familia" className="block font-medium mb-2">Familia padre</label>
                    <Dropdown
                        id="padre-familia"
                        value={values.padreId}
                        options={padreOptions(familias)}
                        onChange={(e) => setField('padreId', e.value)}
                        className="w-full"
                        placeholder="Selecciona familia padre"
                        filter
                        filterPlaceholder="Buscar familia..."
                    />
                </div>
                <div className="field">
                    <label htmlFor="orden-familia" className="block font-medium mb-2">Prioridad / Orden</label>
                    <div className="flex align-items-center gap-3">
                        <InputNumber
                            id="orden-familia"
                            value={values.orden}
                            onValueChange={(e) => setField('orden', e.value || 0)}
                            className="w-full"
                            min={0}
                            placeholder="0"
                            disabled={values.ordenAuto}
                        />
                        <div className="flex align-items-center gap-2">
                            <Checkbox
                                inputId="orden-auto"
                                checked={values.ordenAuto}
                                onChange={(e) => setField('ordenAuto', e.checked)}
                            />
                            <label htmlFor="orden-auto" className="cursor-pointer whitespace-nowrap">Automático</label>
                        </div>
                    </div>
                </div>
            </div>
        </Dialog>
    );
};
